/**
 * Copyright (c) eventlint. All Rights Reserved.
 *
 *
 * @summary
 * @author Segev {CJ} Shmueli <cj@segevs.com>
 *
 * Created: 7/1/2022
 */

import React, { useEffect } from "react";
import LoginComponent from "../components/Login";
import {
    app,
    analytics
} from '../config';

import {
    getFunctions,
    httpsCallable,
} from 'firebase/functions';
import {
    logEvent,

} from 'firebase/analytics';
import { useSearchParams } from "react-router-dom";


export const AuthContext = React.createContext<any>(null);


export const AuthProvider = ({ children }: any) => {
    const [searchParams] = useSearchParams();

    const [authenticating, setAuthenticating] = React.useState<boolean>(false);
    const [isAuthenticated, setIsAuthenticated] = React.useState<boolean>(false);
    const [user, setUser] = React.useState<any>(null);

    useEffect(() => {
        const code = localStorage.getItem('code') ?? searchParams.get('__c');

        if (code) {
            login(code).catch(() => { });
        }
    }, [searchParams]);



    const logout = () => {
        localStorage.removeItem('code');
        setIsAuthenticated(false);
        setUser(null);
    }

    const login = (code: string) => {
        setAuthenticating(true);

        return httpsCallable(getFunctions(app), 'tokens-verify')({ code }).then(res => {
            if (res.data === null) {
                throw new Error('Invalid access code');
            }

            setIsAuthenticated(true);
            setUser(res.data);

            logEvent(analytics, 'login', {
                ...(res.data as any)
            })

            localStorage.setItem('code', code);
        }).finally(() => {
            setAuthenticating(false);
        });
    }

    return (<AuthContext.Provider value={{
        login,
        logout,
        isAuthenticated,
        authenticating,
        user,
    }}>{isAuthenticated ? children : <LoginComponent />}</AuthContext.Provider>);
}

export const useAuth = () => {
    return React.useContext(AuthContext);
}